const prebid = require('./module');

/**
 * @module prebid
 */
window.advert = window.advert || {};
window.advert.modules = window.advert.modules || [];
window.advert.modules.push(['prebid', prebid]);
